import { render, staticRenderFns } from "./CRUDTableStaffExercise.vue?vue&type=template&id=565b822c&scoped=true"
import script from "./CRUDTableStaffExercise.vue?vue&type=script&lang=js"
export * from "./CRUDTableStaffExercise.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableStaffExercise.vue?vue&type=style&index=0&id=565b822c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565b822c",
  null
  
)

export default component.exports